import React, { useEffect, useState } from 'react';
import {
  Col,
  Container,
  Form,
  InputGroup,
  Nav,
  Row,
  Tab
} from 'react-bootstrap';
import Feedback from '../../components/feedbackNote/Feedback';
import Image from 'react-bootstrap/Image';
import Search from '../../assets/images/search-line.svg';
import Policies from './Policies';
import { useAppDispatch } from '../../app/hooks';
import { GetEthicsPoliciesMrise } from '../../features/ethicspolicies/getEpolicyMrise';
import { GetEthicsPolicies } from '../../features/ethicspolicies/ethicspolicySlice';

const PolicyList = () => {
  const PolicyTabs: any = [
    { name: 'ETHICS', title: 'ETHICS' },
    { name: 'POSH', title: 'POSH - Internal Committee' }
  ];
  const dispatch = useAppDispatch();

  useEffect(() => {
    getPolicyList();
  }, []);

  const [policyType, setPolicyType] = useState<any>(PolicyTabs?.[0]?.name);

  const userDetails = localStorage.getItem('userDetails');
  const userDetailsList: any = userDetails;
  const policySourceType = JSON.parse(userDetailsList);

  const getPolicyList = () => {
    if (policySourceType?.mahindraCompanyList?.policySource === true) {
      // call ethics and governace policy from eng portal
      let companyId: number = 24;
      // console.log(companyId);
      const fetchPolicy = async () => {
        await dispatch(GetEthicsPolicies(companyId));
      };
      fetchPolicy();
    } else {
      // call ethics and governace policy from mrise portal
      const fetchPolicyMrise = async () => {
        await dispatch(GetEthicsPoliciesMrise(policyType));
      };
      fetchPolicyMrise();
    }
  };

  useEffect(() => {
    getPolicyList();
  }, [policyType]);

  const handleChange = (key: any = 0) => {
    if (key) {
      setPolicyType(PolicyTabs?.[key]?.name);
    }
  };

  return (
    <Container className='mob-lr-padding0' fluid>
      <Feedback pageName='Policies' />
      <Row>
        <Col lg={6} md={6} sm={6}>
          <h3 style={{ color: '#fff' }}>Policies</h3>
        </Col>
        <Col sm={2}></Col>
      </Row>
      <Row style={{ marginTop: 15 }}>
        <Col xs={12} md={12}>
          <Tab.Container defaultActiveKey={0} onSelect={handleChange}>
            <Row style={styles.divWhite} className='mx-auto pb-0'>
              <Col sm={12} className='px-0'>
                <Nav>
                  {PolicyTabs?.map((obj: any, index: any) => {
                    return (
                      <Nav.Item style={styles.tabHeading} key={index}>
                        <Nav.Link className='tabs1' eventKey={index}>
                          {obj?.title}
                        </Nav.Link>
                      </Nav.Item>
                    );
                  })}
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey={0} key={0}>
                    <Policies type='ETHICS' />
                  </Tab.Pane>
                  <Tab.Pane eventKey={1} key={1}>
                    <Policies type='POSH' />
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </Col>
      </Row>
    </Container>
  );
};

const styles: any = {
  heading: {
    fontFamily: 'Georama-Regular',
    fontSize: '16px',
    fontWeight: '600'
  },
  image1: {
    width: '24px',
    height: '24px'
  },
  star: {
    color: '#e31837'
  },
  text1: {
    fontFamily: 'Georama-Regular',
    fontSize: '16px',
    fontWeight: 'normal',
    border: 'solid 1px #e4e4e4',
    borderTop: '0px',
    borderLeft: '0px',
    borderRight: '0px',
    color: '#6d6e71',
    textAlign: 'left',
    paddingLeft: '0.5rem'
  },
  button: {
    padding: '13px 20px',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: 400,
    fontStretch: 'normal',
    fontStyle: 'normal',
    borderRadius: '0',
    backgroundColor: '#e31837',
    letterSpacing: 'normal',
    border: '0px',
    color: '#fff',
    float: 'right'
  },
  button1: {
    padding: '13px 15px',
    fontFamily: 'Georama-Regular',
    fontSize: '12px',
    fontWeight: '500',
    fontStretch: 'normal',
    fontStyle: 'normal',
    borderRadius: '0',
    backgroundColor: '#ffffff',
    border: '1px solid #e31837',
    letterSpacing: 'normal',
    color: '#e31837'
  },
  divWhite: {
    backgroundColor: '#ffffff',
    paddingTop: '20px',
    margin: '0px',
    paddingLeft: '10px',
    paddingRight: '10px'
  },
  divGrey: {
    backgroundColor: 'rgb(250, 249, 249)',
    paddingTop: '20px',
    margin: '0px',
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingBottom: '20px',
    borderTop: '1px solid #eee;'
  },
  delcontent: {
    fontSize: '16px',
    color: '#242424'
  }
};

export default PolicyList;
